(function (module) {
  'use strict';
  module.directive('imageFileSelect', ['$scope', function ($scope) {
    return {
      link: function($scope,el) {
        
        el.bind("change", function(e) {      
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })      
      }    
    };
  }])
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/directives/imageFileSelect.directive.js